export default __webpack_public_path__ + "static/media/central_parc_from_top.021390af.jpg";